import React from 'react';
import { Result } from 'antd';
import { useGetFinancialHold } from '../hooks/useGetFinancialHold';
import { useContextValue } from '../Context';
import SimplePage from '../layout/SimplePage/SimplePage';
import Container from '../layout/Container/Container';

interface FinancialHoldGateProps {
  children: React.ReactNode;
}

/**
 * Replaces the page with an "Enrollment Blocked" notice when the logged-in
 * user has a financial hold. Loading, errors and logged-out users fall
 * through to the page; the register endpoint still enforces the hold.
 */
const FinancialHoldGate: React.FC<FinancialHoldGateProps> = ({ children }) => {
  const { state } = useContextValue();
  const { data } = useGetFinancialHold();

  if (state.user?.id && data?.hasFinancialHold === true) {
    return (
      <SimplePage>
        <Container>
          <div data-testid="financial-hold-notice">
            <Result
              status="warning"
              title="Enrollment Blocked"
              subTitle="There is a financial hold on your account. You may not enroll until this has been resolved. Please contact the STAR office."
            />
          </div>
        </Container>
      </SimplePage>
    );
  }

  return <>{children}</>;
};

export default FinancialHoldGate;
